import jQuery from "jquery";
window.$ = jQuery;
window.jQuery = jQuery;

require("./carrito-modal");

import DataTable from "datatables.net-dt";
window.DataTable = DataTable;

require("dropzone");

// resources/assets/js/app.js

jQuery(function () {
    window.root_url = $("#root_url").val();
    window.dashboard_url = $("#dashboard_url").val();
    window.current_url = $("#current_url").val();

    //body height
    var height_main_menu = $("#main-menu").css("height") ?? 0;
    var height_footer = $("#footer").css("height") ?? 0;

    $("#content").css(
        "min-height",
        "calc((100vh - " + height_main_menu + ") - " + height_footer + ")",
    );
    $("#body-row").css(
        "min-height",
        "calc((100vh - " + height_main_menu + ") - " + height_footer + ")",
    );

    $("#search_topbar").on("click", function () {
        $("#search_topbar").attr("size", "60");
    });

    $("#search_topbar").on("focusout", function () {
        $("#search_topbar").attr("size", "");
    });

    /********* main sidebar ***********/

    // Hide submenus
    //$('#body-row .collapse').collapse('hide');

    // Collapse/Expand icon
    $("#collapse-icon").addClass("fa-angle-double-left");

    // Collapse click
    $("[data-toggle='sidebar-collapse']").on("click", function () {
        SidebarCollapse();
    });

    /********* right sidebar ***********/

    $("#show_history, #show_alerts").on("click", function () {
        var operation = $(this).attr("id").split("_").pop();

        $("#show_history, #show_alerts").parent().removeClass("active");

        var before_sidebar_visible = $("[id^='show_sidebar_']").is(":visible");

        if ($("#show_sidebar_" + operation).is(":visible")) {
            $("[id^='show_sidebar_']").hide();
            $("#show_" + operation)
                .parent()
                .remove("active");
        } else {
            $("[id^='show_sidebar_']").hide();
            $("#show_sidebar_" + operation).show();
            $("#show_" + operation)
                .parent()
                .addClass("active");
        }

        var after_sidebar_visible = $("[id^='show_sidebar_']").is(":visible");

        if (before_sidebar_visible != after_sidebar_visible) {
            $("#body-main").toggleClass("col-12 col-9");
        }
    });

    $("#close_history, #close_alerts").on("click", function () {
        var operation = $(this).attr("id").split("_").pop();

        $("#show_sidebar_" + operation).hide();
        $("#show_" + operation)
            .parent()
            .removeClass("active");

        $("#body-main").toggleClass("col-12 col-9");
    });

    /**********************************/

    function SidebarCollapse() {
        $("#sidebar-container .menu-collapsed").toggleClass("d-none");
        $(".sidebar-submenu").toggleClass("d-none");
        $(".submenu-icon").toggleClass("d-none");

        $("#sidebar-container").toggleClass("col-2 col-0-5");
        $("#body-content").toggleClass("col-10 col-11-5");

        // Treating d-flex/d-none on separators with title
        var SeparatorTitle = $(".sidebar-separator-title");

        if (SeparatorTitle.hasClass("d-flex")) {
            SeparatorTitle.removeClass("d-flex");
        } else {
            SeparatorTitle.addClass("d-flex");
        }

        //padding icons on collapse
        if ($("#sidebar-container i").hasClass("pt-1")) {
            $("#sidebar-container i").removeClass("pt-1");
        } else {
            $("#sidebar-container i").addClass("pt-1");
        }

        // Collapse/Expand icon
        $("#collapse-icon").toggleClass(
            "fa-angle-double-left fa-angle-double-right",
        );
    }

    window.openModal = (modalId, account = null) => {
        $(`#${modalId}`).removeClass("hidden").addClass("flex");

        if (modalId == "modAlddMailHosts") {
            const form = document.getElementById("mailAccountForm");
            const title = document.getElementById("modalTitle");

            if (account) {
                title.textContent = "Editar Cuenta de Correo";
                form.action = `admin/mailaccounts/update/${account.id}`;
                form.name.value = account.name;
                form.from_address.value = account.from_address;
                form.from_name.value = account.from_name ?? "";
                form.host.value = account.host;
                form.port.value = account.port;
                form.username.value = account.username;
                form.password.value = "";
                form.encryption.value = account.encryption ?? "";
            } else {
                title.textContent = "Añadir Cuenta de Correo";
                form.action = "admin/mailaccounts/store";
                form.reset();
            }
        }
    };

    window.openModaleditarPlantillaMail = (plantilla) => {
        $("#editar-plantilla-id").val(plantilla.id);
        $("#editar-nombre-plantilla-email").val(plantilla.name);
        $("#editar-descripcion-plantilla-email").val(plantilla.descripcion);
        $("#editar-asunto-plantilla-email").val(plantilla.asunto);
        $("#editar-to-plantilla-email").val(plantilla.emails.join(", "));
        $("#editar-mail-account-id").val(plantilla.mail_account_id);

        openModal("modalEditarPlantillaMail");
    };

    window.closetooltip = (modalId) => {
        const modal = document.getElementById(modalId);
        if (!modal) {
            var x = document.getElementById("modaltip");
            x.style.display = "none";
            return;
        }

        if (modal.classList.contains("flex")) {
            modal.classList.add("hidden");
            modal.classList.remove("flex");
        }

        if (window.getComputedStyle(modal).display !== "none") {
            modal.style.display = "none";
            return;
        }
    };
});
